import {Component} from '@angular/core';
import {BaseDialogType} from '../base-dialog-directives';
import { ResizableDirective } from '../../../../Directives/resizable/resizable.directive';
import { NgStyle } from '@angular/common';

@Component({
    selector: 'ins-modal-dialog',
    templateUrl: './modal-dialog.component.html',
    styleUrls: ['./modal-dialog.component.scss'],
    imports: [ResizableDirective, NgStyle]
})
export class ModalDialogComponent extends BaseDialogType {

}
